import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Box } from "@chakra-ui/react";
import { useState, Suspense, lazy } from "react";
import Navbar from "./components/header/Navbar";
import Footer from "./components/header/Footer";
import ScrollToTop from "./config/ScrollToTop";
import Popup from "./components/popup/Popup";
import Loading from "./components/Errorandloading/Loading";
import Error from "./components/Errorandloading/Error";
// import { JoinJewelleryShop } from "./components/home/components/JoinJewelleryShop";
import BlogScreenWrapper from "./components/Blogs/components/BlogScreenWrapper";
import DiscoverAll from "./components/discovercollection/types/DiscoverAll";
import { useBreakpointValue } from "@chakra-ui/react";
import WhatsappRedirect from "./components/WhatsappRedirect";
import Instagram from "./components/Instagram";
import SuccessPage from "./components/productDetails/orders/SuccessPage";
import CancelPage from "./components/productDetails/orders/CancelPage";
import OrderDetails from "./components/AccountInformation/OrderDetails";
import BespokeProductDetails from "./components/bespoke/BespokeProductDetails";

// Lazy-loaded route components
const Home = lazy(() => import("./components/home/Home"));
const Jewellery = lazy(() => import("./components/jewellery/Jewellery"));
const ProductDetails = lazy(() =>
  import("./components/productDetails/ProductDetails")
);
const ShoppingBag = lazy(() => import("./components/shoppingBag/ShoppingBag"));
const HighJewellery = lazy(() =>
  import("./components/highjewellery/HighJewellery")
);
const Necklace = lazy(() => import("./components/necklace/Necklace"));
const Collection1 = lazy(() =>
  import("./components/discovercollection/types/Collection1")
);
const Collection2 = lazy(() =>
  import("./components/discovercollection/types/Collection2")
);
const Collection3 = lazy(() =>
  import("./components/discovercollection/types/Collection3")
);
const Checkout = lazy(() => import("./components/checkout/Checkout"));
const Services = lazy(() => import("./components/services/Services"));
const ServiceDetail = lazy(() =>
  import("./components/services/components/ServiceDetails")
);
const Login = lazy(() => import("./components/login/Login"));
const Create = lazy(() => import("./components/login/Create"));
const Overview = lazy(() => import("./components/AccountInformation/Overview"));
const MyProfile = lazy(() =>
  import("./components/AccountInformation/Myprofile")
);
const Order = lazy(() => import("./components/AccountInformation/Order"));
const Message = lazy(() => import("./components/AccountInformation/Message"));
// const PolicyCenter = lazy(() => import("./components/policy/PolicyCenter"));
const Custom = lazy(() => import("./components/policy/Custom"));
const Cancellation = lazy(() => import("./components/policy/Cancellation"));
const Contact = lazy(() => import("./components/Contact/Contact"));
const AppointementMain = lazy(() =>
  import("./components/BookAppointement/AppointementMain")
);
const StoreLocator = lazy(() => import("./components/store/StoreLocator"));
const Logout = lazy(() => import("./components/AccountInformation/Logout"));
const MyAppointment = lazy(() =>
  import("./components/AccountInformation/Myappointment")
);
const CompleteProfile = lazy(() =>
  import("./components/AccountInformation/CompleteProfile")
);
const Track = lazy(() => import("./components/AccountInformation/Track"));
const Points = lazy(() => import("./components/AccountInformation/Points"));
const TermsAndCondition = lazy(() =>
  import("./components/policy/TermsAndCondition")
);
const PrivacyPolicy = lazy(() => import("./components/policy/PrivacyPolicy"));
const Hotstamping = lazy(() =>
  import("./components/services/components/screens/Hotstamping")
);
const Engraving = lazy(() =>
  import("./components/services/components/screens/Engraving")
);
const Stone = lazy(() =>
  import("./components/services/components/screens/Stone")
);
const ClickandCollect = lazy(() =>
  import("./components/services/components/screens/ClickandCollect")
);
const FandQ = lazy(() => import("./components/FandQ/FandQ"));
const SignatureBox = lazy(() =>
  import("./components/services/components/screens/Signaturebox")
);
const Personalizedgift = lazy(() =>
  import("./components/services/components/screens/Personalizedgift")
);
const WatchesPage = lazy(() =>
  import("./components/services/components/watches/WatchesPage")
);
const JewelleryMain = lazy(() =>
  import("./components/services/components/jewellery/JewelleryMain")
);
const AboutusMain = lazy(() => import("./components/aboutus/AboutusMain"));
const Bespoke = lazy(() => import("./components/bespoke/Bespoke"));
const CraftsmanMain = lazy(() =>
  import("./components/craftsmanandcertificate/CraftsmanMain")
);
const BlogMain = lazy(() => import("./components/Blogs/BlogMain"));
const Franchise = lazy(() => import("./components/Franchise/Franchise"));

function App() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const ResponsiveNavbar = useBreakpointValue({
    base: <Navbar />,
    md: <Navbar />,
  });

 
  return (
    <Router>
      <ScrollToTop />
      <Popup setIsPopupOpen={setIsPopupOpen} />
      {ResponsiveNavbar}
      <Box opacity={isPopupOpen ? 0.1 : 1} transition="opacity 0.3s ease">
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/jewellery" element={<HighJewellery />} />
            <Route path="/high-jewellery" element={<HighJewellery />} />
            <Route path="/high-jewellery/:necklace_id" element={<Necklace />} />
            <Route path="/discover-collection" element={<Collection1 />} />
            <Route path="/discover-collection2" element={<Collection2 />} />
            <Route path="/discover-collection3" element={<Collection3 />} />
            <Route path="/jewellery/:category" element={<Jewellery />} />
            <Route path="/discover-all" element={<DiscoverAll />} />
            {/* <Route path="/discover-all/:category" element={<DiscoverAll />} /> */}
            <Route path="/product/:product_id" element={<ProductDetails />} />
            <Route path="/shopping-bag" element={<ShoppingBag />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:id" element={<ServiceDetail />} />
            <Route path="/login" element={<Login />} />
            <Route path="/create" element={<Create />} />
            <Route path="/overview" element={<Overview />} />
            <Route path="/myprofile" element={<MyProfile />} />
            <Route path="/order" element={<Order />} />
            <Route path="/order/:orderId" element={<OrderDetails />} />
            <Route path="/message" element={<Message />} />
            {/* <Route path="/policy" element={<PolicyCenter />} /> */}
            <Route path="/custom" element={<Custom />} />
            <Route path="/cancellation" element={<Cancellation />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/appointment" element={<AppointementMain />} />
            <Route path="/store" element={<StoreLocator />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/myappointment" element={<MyAppointment />} />
            <Route path="/profile" element={<CompleteProfile />} />
            <Route path="/track" element={<Track />} />
            <Route path="/points" element={<Points />} />
            <Route path="/termsandcondition" element={<TermsAndCondition />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route path="/hotstamping" element={<Hotstamping />} />
            <Route path="/engraving" element={<Engraving />} />
            <Route path="/soulstone" element={<Stone />} />
            <Route path="/clickandcollect" element={<ClickandCollect />} />
            <Route path="/fandq" element={<FandQ />} />
            <Route path="/services/fandq" element={<FandQ />} />
            <Route path="/fandq/:section" element={<FandQ />} />
            <Route path="/signaturebox" element={<SignatureBox />} />
            <Route path="/personalizedgift" element={<Personalizedgift />} />
            <Route path="/watch-care" element={<WatchesPage />} />
            <Route path="/jewellery-care" element={<JewelleryMain />} />
            <Route path="/about-us" element={<AboutusMain />} />
            <Route path="/craftsman" element={<CraftsmanMain />} />
            <Route path="/blogs" element={<BlogMain />} />
            <Route path="/blogs/:id" element={<BlogScreenWrapper />} />
            <Route path="/franchise" element={<Franchise />} />
            <Route path="/whatsapp" element={<WhatsappRedirect />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/cancel" element={<CancelPage />} />
            <Route path="/bespoke/:type?" element={<Bespoke />} />
            <Route path="/bespoke/product/:product_id" element={<BespokeProductDetails />} />
            {/* Fallback route for unmatched paths */}
            <Route path="*" element={<Error />} />
          </Routes>
        </Suspense>
        {/* <JoinJewelleryShop /> */}
        <Instagram/>
        <Footer />
      </Box>
    </Router>
  );
}

export default App;
